module.exports = __webpack_public_path__ + "img/Default.bdc919fc.png";